"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const poresskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-poresskin` : '') + (description ? ` desc-poresskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-poresskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-poresskin"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26120_2744)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.53 15.19a.72.72 0 1 1 0 1.44.72.72 0 0 1 0-1.44Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.52 14.24a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.92Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.29 12.21a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.12 12.26a.72.72 0 1 1 0 1.44.72.72 0 0 1 0-1.44Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27.56A7.82 7.82 0 0 1 12 .24c.64.2 1.22.52 1.66.96a8.2 8.2 0 0 1 6.5 2.78c1.56 1.85 2.23 4.46 1.81 7.4a16.43 16.43 0 0 1-1.18 4.45 5.32 5.32 0 0 1-.6 2.26l2.7 2.7a1.58 1.58 0 0 1-2.25 2.24l-2.57-2.58a7.8 7.8 0 0 1-3.2 2.51 7.8 7.8 0 0 1-5.74.15l-.37-.15a7.81 7.81 0 0 1-3.97-3.78A10.84 10.84 0 0 1 .72 10.8v-.53C.81 4.88 4.01 1.74 7.27.56Zm11.8 18.1c-.1.26-.21.5-.34.75l2.77 2.77.06.05a.39.39 0 0 0 .49-.05.39.39 0 0 0 .1-.27v-.08a.38.38 0 0 0-.1-.2l-2.98-2.96ZM11.7 6.34l-.3.02a6.32 6.32 0 0 0-5.87 6.32v2.86a6.34 6.34 0 0 0 6.3 6.56 6.3 6.3 0 0 0 2.47-.5l.3-.14c.3-.15.59-.32.87-.52a5.32 5.32 0 0 1-3.05-.97 9.34 9.34 0 0 1-1.85-.06c-.4-.06-.77-.15-1.1-.26a.75.75 0 0 1 .49-1.42c.22.08.5.14.82.19l.2.02a5.32 5.32 0 0 1-.4-4.86l-.37.17c-.31.13-.8.3-1.29.3a3.6 3.6 0 0 1-1.29-.3 5.92 5.92 0 0 1-.57-.29h-.01a.75.75 0 0 1 .75-1.3l.03.02.08.04.31.15c.27.11.53.19.7.19a2 2 0 0 0 .7-.2c.13-.04.24-.1.31-.14l.09-.04.02-.02a.75.75 0 0 1 1.1.4 5.32 5.32 0 0 1 6.79-1.66 6.34 6.34 0 0 0-6.07-4.56h-.16Zm3.57 5.17a4.12 4.12 0 0 0-3.9 4.21l.04.02h.01l.05.02.16.07a.96.96 0 1 1 1.82.17l.04.07c.18.35.06.76-.26.97l-.07.04-.03.01-.08.04-.26.1a2.54 2.54 0 0 1-1.02.17 4.12 4.12 0 0 0 .73 1.06l.34-.04.24-.04c.18-.03.34-.07.48-.12a.96.96 0 1 1 1.1.71.75.75 0 0 1-.35.6 4.1 4.1 0 0 0 2.64-.1c.11-.15.22-.32.32-.49l-.14.01a1.2 1.2 0 1 1 .9-2c.06-.33.1-.68.1-1.02a.72.72 0 0 1 .02-1.16l.04-2.13v-.17a4.07 4.07 0 0 0-2.92-1Zm-3.68-9.82a6.34 6.34 0 0 0-3.8.29c-2.74 1-5.48 3.62-5.56 8.35v.46a9.35 9.35 0 0 0 1.81 5.44 7.87 7.87 0 0 1-.01-.72v-2.84a7.85 7.85 0 0 1 7.55-7.83A1.6 1.6 0 0 0 13 3.24a1.38 1.38 0 0 0-.28-.87c-.23-.3-.6-.53-1.13-.69Zm2.87 1.05a3.11 3.11 0 0 1-.58 2.37 7.83 7.83 0 0 1 5.8 7.23c.18.23.33.47.47.73.15-.6.26-1.24.36-1.9.37-2.59-.24-4.74-1.48-6.22a6.5 6.5 0 0 0-4.57-2.21Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26120_2744"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = poresskin;